export const quizQuestions = [
  // Food Independence & Land-Based Skills
  {
    id: 1,
    category: "Food Independence",
    question: "How much food do you personally grow or source locally?",
    options: [
      { value: 1, label: "None" },
      { value: 2, label: "Small garden or occasional local food" },
      { value: 3, label: "Seasonal or consistent local sourcing" },
      { value: 4, label: "Significant portion of my food" }
    ]
  },
  {
    id: 2,
    category: "Food Independence",
    question: "If grocery stores shut down for two weeks, you would:",
    options: [
      { value: 1, label: "Panic" },
      { value: 2, label: "Scramble but manage" },
      { value: 3, label: "Be uncomfortable but fine" },
      { value: 4, label: "Be largely unaffected" }
    ]
  },
  {
    id: 3,
    category: "Food Independence",
    question: "Do you practice food preservation (canning, fermenting, drying)?",
    options: [
      { value: 1, label: "No" },
      { value: 2, label: "I've tried once or twice" },
      { value: 3, label: "I use a few methods" },
      { value: 4, label: "I regularly preserve food" }
    ]
  },
  {
    id: 4,
    category: "Food Independence",
    question: "Where does most of your food come from?",
    options: [
      { value: 1, label: "Big-box stores" },
      { value: 2, label: "Grocery + some local food" },
      { value: 3, label: "Farmers / local producers" },
      { value: 4, label: "Mostly local or self-produced" }
    ]
  },
  // Energy & Infrastructure Independence
  {
    id: 5,
    category: "Energy & Infrastructure",
    question: "How dependent are you on centralized utilities (electricity, heat, water, sewer etc)?",
    options: [
      { value: 1, label: "Fully dependent" },
      { value: 2, label: "Mostly dependent" },
      { value: 3, label: "Partial backups" },
      { value: 4, label: "Largely self-sufficient" }
    ]
  },
  {
    id: 6,
    category: "Energy & Infrastructure",
    question: "If the power went out for 72 hours, you would:",
    options: [
      { value: 1, label: "Be completely disrupted" },
      { value: 2, label: "Struggle but cope" },
      { value: 3, label: "Function with inconvenience" },
      { value: 4, label: "Operate normally" }
    ]
  },
  {
    id: 7,
    category: "Energy & Infrastructure",
    question: "Do you understand how your home systems work (heat, water, power)?",
    options: [
      { value: 1, label: "Not really" },
      { value: 2, label: "Basic understanding" },
      { value: 3, label: "Can troubleshoot basics" },
      { value: 4, label: "Can repair and adapt" }
    ]
  },
  // Financial Sovereignty (Bitcoin-Centric)
  {
    id: 8,
    category: "Financial Sovereignty",
    question: "Which best describes your relationship with Bitcoin?",
    options: [
      { value: 1, label: "I don't own any" },
      { value: 2, label: "I own some on an exchange" },
      { value: 3, label: "I self-custody some Bitcoin" },
      { value: 4, label: "I self-custody Bitcoin and actively use it" }
    ]
  },
  {
    id: 9,
    category: "Financial Sovereignty",
    question: "How confident are you in self-custody (you personally control your Bitcoin by holding the private keys)?",
    options: [
      { value: 1, label: "I don't self-custody" },
      { value: 2, label: "I rely on others for setup/help" },
      { value: 3, label: "I manage my own wallet securely" },
      { value: 4, label: "I understand backups, multisig, and opsec" }
    ]
  },
  {
    id: 10,
    category: "Financial Sovereignty",
    question: "If banks were inaccessible tomorrow, how prepared would you be financially?",
    options: [
      { value: 1, label: "Not prepared" },
      { value: 2, label: "Some cash, no Bitcoin access" },
      { value: 3, label: "Bitcoin in self-custody but limited experience using it" },
      { value: 4, label: "Bitcoin in self-custody and confident transacting" }
    ]
  },
  {
    id: 11,
    category: "Financial Sovereignty",
    question: "How well do you understand why Bitcoin exists?",
    options: [
      { value: 1, label: "I don't" },
      { value: 2, label: "At a high level" },
      { value: 3, label: "I understand monetary debasement and incentives" },
      { value: 4, label: "I can clearly explain Bitcoin vs fiat to others" }
    ]
  },
  {
    id: 12,
    category: "Financial Sovereignty",
    question: "How do you primarily save for the future?",
    options: [
      { value: 1, label: "Fiat savings" },
      { value: 2, label: "Traditional investments only" },
      { value: 3, label: "Mix of traditional assets and Bitcoin" },
      { value: 4, label: "Bitcoin as my primary long-term savings" }
    ]
  },
  // Health Autonomy & Natural Medicine
  {
    id: 13,
    category: "Health Autonomy",
    question: "When you're sick, your first instinct is to:",
    options: [
      { value: 1, label: "See a conventional doctor" },
      { value: 2, label: "Google symptoms" },
      { value: 3, label: "Try natural remedies first" },
      { value: 4, label: "Address root causes proactively" }
    ]
  },
  {
    id: 14,
    category: "Health Autonomy",
    question: "What best describes your healthcare approach?",
    options: [
      { value: 1, label: "Fully institutional" },
      { value: 2, label: "Mostly conventional with some alternatives" },
      { value: 3, label: "Mix of conventional and naturopathic" },
      { value: 4, label: "Natural, preventative, and holistic" }
    ]
  },
  {
    id: 15,
    category: "Health Autonomy",
    question: "Have you worked with a naturopathic doctor or holistic practitioner?",
    options: [
      { value: 1, label: "No" },
      { value: 2, label: "Once or briefly" },
      { value: 3, label: "Yes, occasionally" },
      { value: 4, label: "Yes, as my primary care" }
    ]
  },
  {
    id: 16,
    category: "Health Autonomy",
    question: "How well do you understand nutrition as medicine?",
    options: [
      { value: 1, label: "Not much" },
      { value: 2, label: "Basic ideas" },
      { value: 3, label: "Strong understanding" },
      { value: 4, label: "Deeply intentional and applied" }
    ]
  },
  {
    id: 17,
    category: "Health Autonomy",
    question: "If the healthcare system became unavailable, how prepared would you be?",
    options: [
      { value: 1, label: "Not at all" },
      { value: 2, label: "Slightly" },
      { value: 3, label: "Moderately" },
      { value: 4, label: "Highly prepared" }
    ]
  },
  // Education, Mindset & Sovereignty
  {
    id: 18,
    category: "Mindset & Sovereignty",
    question: "Where do you primarily learn about money, health, and systems?",
    options: [
      { value: 1, label: "Mainstream media and institutions" },
      { value: 2, label: "Mix of mainstream and independent sources" },
      { value: 3, label: "Mostly independent educators" },
      { value: 4, label: "Self-directed and intentional" }
    ]
  },
  {
    id: 19,
    category: "Mindset & Sovereignty",
    question: "How often do you question official narratives?",
    options: [
      { value: 1, label: "Rarely" },
      { value: 2, label: "Sometimes" },
      { value: 3, label: "Often" },
      { value: 4, label: "Always" }
    ]
  },
  {
    id: 20,
    category: "Mindset & Sovereignty",
    question: "When systems fail or disappoint you, you:",
    options: [
      { value: 1, label: "Feel powerless" },
      { value: 2, label: "Look for new authorities" },
      { value: 3, label: "Take personal responsibility" },
      { value: 4, label: "Adapt, learn, and build alternatives" }
    ]
  }
];

export const sovereigntyLevels = [
  {
    range: [20, 35],
    level: "System Dependent",
    emoji: "🧱",
    color: "from-red-500 to-orange-500",
    summary: "You are still operating inside the system—by default, not by choice.",
    description: `Right now, most of your money flows through banks, food comes from centralized supply chains, health decisions are outsourced to institutions, and education comes from "approved" sources.\n\nThat doesn't make you lazy or foolish—it makes you normal. But it also makes you fragile. Your life depends on systems you don't control and don't fully understand.`,
    goodNews: "You've already taken the most important step: awareness. Sovereignty doesn't start with action—it starts with seeing reality clearly.",
    leveragePoint: "Money. You cannot build sovereignty on broken money.",
    nextSteps: [
      "Start with the Unshackled Living Podcast - episodes on why modern money keeps you dependent",
      "Learn why Bitcoin is not \"crypto\"",
      "Take the Bitcoin Fundamentals Course"
    ]
  },
  {
    range: [36, 50],
    level: "Awakening",
    emoji: "🌱",
    color: "from-orange-500 to-yellow-500",
    summary: "You know something is broken—but you're still halfway in.",
    description: `You've started questioning fiat money and inflation, institutional healthcare, and centralized narratives.\n\nYou may own some Bitcoin (likely on an exchange), experiment with natural remedies, and feel pulled between "comfort" and "truth". You're awake—but not yet free.`,
    goodNews: "The tension you're feeling is uncomfortable—and necessary. You can see the problems now, but you haven't fully exited the dependencies.",
    leveragePoint: "Self-custody and responsibility. Sovereignty begins when you become the point of failure.",
    nextSteps: [
      "Focus on self-custody episodes in the podcast",
      "Learn about personal responsibility and prevention-based health",
      "Take the Bitcoin Fundamentals Course to build conviction—not just exposure"
    ]
  },
  {
    range: [51, 65],
    level: "Building Sovereignty",
    emoji: "🔨",
    color: "from-yellow-500 to-green-500",
    summary: "You're actively reclaiming control—but still strengthening foundations.",
    description: `You likely self-custody Bitcoin, question institutions by default, use natural medicine and preventative health, source some food locally, and take responsibility for outcomes.\n\nYou're no longer dependent—you're intentional.`,
    goodNews: "You're strong in mindset, awareness, and action. Now focus on depth and resilience.",
    leveragePoint: "Depth and resilience. Sovereignty isn't about dabbling—it's about durability under pressure.",
    nextSteps: [
      "Could you explain Bitcoin clearly to a beginner?",
      "Could your family operate if systems failed?",
      "Lean into episodes on long-term resilience and building parallel systems"
    ]
  },
  {
    range: [66, 80],
    level: "Unshackled",
    emoji: "🔓",
    color: "from-green-500 to-emerald-500",
    summary: "You are living intentionally outside fragile systems.",
    description: `You use Bitcoin as a primary savings technology, self-custody confidently, treat health as a daily practice, question authority by default, and build alternatives instead of complaining.\n\nYou understand that sovereignty is not rebellion—it's responsibility.`,
    goodNews: "This stage isn't about \"more freedom.\" It's about leadership. Others are watching your choices, your calm, and your preparedness.",
    leveragePoint: "Leadership and community building. True sovereignty isn't isolation—it's building parallel systems others can step into.",
    nextSteps: [
      "Use the Unshackled Living Podcast as a signal amplifier",
      "Share episodes and start conversations",
      "Use the Bitcoin Fundamentals Course to teach family and friends"
    ]
  }
];

export const getSovereigntyLevel = (score) => {
  return sovereigntyLevels.find(level => score >= level.range[0] && score <= level.range[1]) || sovereigntyLevels[0];
};
